/**
 * Whether the master account the session acts in keeps integration templates: the server's
 * `master-account-integration-templates` flag, evaluated per master account.
 */
import { useQuery } from '@apollo/client/react';
import { GetMasterAccountIntegrationTemplatesEnabledDocument } from '@/graphql';

export interface MasterAccountIntegrationTemplatesEnabled {
  enabled: boolean;
  loading: boolean;
}

export function useMasterAccountIntegrationTemplatesEnabled(
  options: { skip?: boolean } = {}
): MasterAccountIntegrationTemplatesEnabled {
  const { data, loading } = useQuery(GetMasterAccountIntegrationTemplatesEnabledDocument, {
    skip: options.skip,
    fetchPolicy: 'cache-first'
  });
  return {
    enabled: data?.profile?.currentMasterAccount?.integrationTemplatesEnabled === true,
    loading
  };
}
